import {ReactElement} from 'react'

export const DopamineAssistantSendIcon = (): ReactElement => (
  <svg
    aria-hidden="true"
    fill="none"
    height="15"
    viewBox="0 0 24 24"
    width="15"
  >
    <path
      d="M12 19V5M5 12l7-7 7 7"
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth="2.4"
    />
  </svg>
)
